import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-feed-type-not-supported',
  standalone: true,
  imports: [HeaderComponent],
  templateUrl: './feed-type-not-supported.component.html',
  styleUrl: './feed-type-not-supported.component.scss'
})
export class FeedTypeNotSupportedComponent {

}
